// extracted by mini-css-extract-plugin
export default {"swiper":"styles_swiper__Mdkp7"};